<template>
  <div>
    <v-alert type="warning">
      <p>
        {{ $t(`Enabling password protection will make 'Embed on page' and 'Use as widget' stop working.`) }}
      </p>

      <p class="mb-0">
        {{ $t('It will also require integrations to provide a valid password when communicating with the API. See the API documentation for more info.') }}
      </p>
    </v-alert>

    <v-switch
      :input-value="passwordsEnabled"
      class="py-0 my-0"
      :label="$t('Enable password protection')"
      @change="handlePasswordEnabledChange"
    />

    <v-btn
      color="primary"
      class="mb-2"
      small
      @click="showPasswordDialog('create', null)"
    >
      {{ $t('Create password') }}
    </v-btn>

    <v-list>
      <v-list-item
        v-for="password in passwords"
        :key="password.id"
        @click="showPasswordDialog('edit', password)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ password.name }}</v-list-item-title>
          <v-list-item-subtitle v-if="password.valid_from">
            Valid from: {{ password.valid_from.substr(0, 10) }}
          </v-list-item-subtitle>
          <v-list-item-subtitle v-if="password.valid_to">
            Valid to: {{ password.valid_to.substr(0, 10) }}
          </v-list-item-subtitle>
          <v-list-item-subtitle v-if="! password.valid_from && ! password.valid_to">
            {{ $t('No expiration') }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            icon
            color="error"
            @click.stop="deletePassword(password)"
          >
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <portal-password-dialog
      v-model="dialog.show"
      :mode="dialog.mode"
      :faq-id="faqId"
      :password="dialog.password"
    />
  </div>
</template>

<script>
import PortalPasswordDialog from '@/components/faq/PortalPasswordDialog';

export default {
  components: {
    PortalPasswordDialog
  },

  props: {
    faqId: {
      type: Number,
      required: true
    },
    passwordsEnabled: {
      type: Boolean,
      required: false
    },
    passwords: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      dialog: {
        show: false,
        password: null,
        mode: 'create',
      }
    }
  },

  methods: {
    showPasswordDialog(mode, password) {
      this.dialog.mode = mode;
      this.dialog.password = password;
      this.dialog.show = true;
    },

    handlePasswordEnabledChange(value) {
      this.$emit('update:passwords-enabled', value)
    },

    async deletePassword(password) {
      const confirmed = await this.$root.$confirm(
        this.$t('Delete password'),
        this.$t('Are you sure you want to delete this password?')
      );

      if (! confirmed) {
        return;
      }

      const url = this.route('faq-settings.portal.password.destroy', [this.faqId, password.id]);

      this.$inertia.delete(url, {
        preserveState: true,
      });
    }
  }
}
</script>